const cookieName = 'growthbook_id';

export { cookieName };
//# sourceMappingURL=constants.js.map
